<template>
  <section id="partners" class="partners-section animate-box">
    <p class="partner-title">与全球顶尖团队共同成长</p>
    <div class="marquee">
      <div class="marquee-content">
        <span v-for="n in 2" :key="n" class="logo-group">
          <div class="partner-logo" v-for="brand in partners" :key="brand">{{ brand }}</div>
        </span>
      </div>
    </div>
  </section>
</template>

<script setup>
const partners = ['AIGC.Lab', 'NEBULA', 'VUE-TECH', 'NVIDIA', 'APPLE', 'OPENAI', 'FUTURE-D', 'KETANGJIE', 'LAIQIU', 'KESION']
</script>

<style scoped>
.partners-section {
  padding: 60px 0;
  overflow: hidden;
  opacity: 0.8;
}

.partner-title {
  text-align: center;
  font-size: 0.8rem;
  opacity: 0.4;
  letter-spacing: 4px;
  margin-bottom: 30px;
}

.marquee {
  display: flex;
  overflow: hidden;
  user-select: none;
}

.marquee-content {
  display: flex;
  flex-shrink: 0;
  gap: 60px;
  animation: scroll 30s linear infinite;
}

.logo-group {
  display: flex;
  gap: 60px;
}

.partner-logo {
  font-size: 1.5rem;
  font-weight: 900;
  color: #333;
  transition: 0.3s;
  cursor: pointer;
}

.partner-logo:hover {
  color: #fff;
}

@keyframes scroll {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-50%);
  }
}
</style>